/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aicostssubtitle2Inputs */

const en_aicostssubtitle2 = /** @type {(inputs: Aicostssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What each AI feature costs at the provider, at list prices, next to the credits businesses paid for it.`)
};

const de_aicostssubtitle2 = /** @type {(inputs: Aicostssubtitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Was jede KI-Funktion beim Anbieter kostet, zu Listenpreisen, neben den Credits, die Unternehmen dafür bezahlt haben.`)
};

/**
* | output |
* | --- |
* | "What each AI feature costs at the provider, at list prices, next to the credits businesses paid for it." |
*
* @param {Aicostssubtitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aicostssubtitle2 = /** @type {((inputs?: Aicostssubtitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aicostssubtitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aicostssubtitle2(inputs)
	return de_aicostssubtitle2(inputs)
});
export { aicostssubtitle2 as "aiCostsSubtitle" }